<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <PlacementTypesDropdownList
          :placementTypeId="placementTypeId"
          @placementTypeIdChangeHandler="placementTypeId = $event"
        ></PlacementTypesDropdownList>
      </v-col>
      <v-col v-if="placementTypeId === placementTypes.Deal" cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <DealStatusesDropDownList
          :id="dealStatusId"
          label="Deal Status"
          @change="dealStatusId = $event"
        ></DealStatusesDropDownList>
      </v-col>
      <v-col v-if="placementTypeId === placementTypes.Assignment" cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-switch
          v-model="onlyFinalizedContracts"
          label="Show Only Finalized Contracts"
          class="mt-2"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <BusinessEntitiesDropDownList
          v-model="businessEntityId"
          label="Business Entity"
          :clearable="true"
        ></BusinessEntitiesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <ClientsDropDownList
          :id="clientId"
          :businessEntityId="businessEntityId"
          :clearable="true"
          @clientIdChange="clientId = $event"
        ></ClientsDropDownList>
      </v-col>
      <v-col v-if="placementTypeId === placementTypes.DirectPlacement" cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-text-field
          v-model="consultantName"
          label="Consultant"
          outlined
          clearable
        ></v-text-field>
      </v-col>
      <v-col v-else cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <UsersDropDownList
          :userId="consultantId"
          :clearable="true"
          label="Consultant"
          @userIdChange="consultantId = $event"
          @userNameChange="handleUserNameChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-text-field
          v-model="jobTitle"
          label="Job Title"
          outlined
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import PlacementTypesDropdownList from '@/components/placements/PlacementTypesDropdownList'
import { DealStatusesDropDownList } from '@/components/dealStatuses'
import { BusinessEntitiesDropDownList } from '@/components/businessEntities'
import { ClientsDropDownList } from '@/components/clients'
import { UsersDropDownList } from '@/components/users'
import { placementTypes } from '@/lib/enum/placementTypes'

export default {
  components: {
    FilterButtons,
    FilterButtonsSmall,
    PlacementTypesDropdownList,
    DealStatusesDropDownList,
    BusinessEntitiesDropDownList,
    ClientsDropDownList,
    UsersDropDownList
  },
  data () {
    return {
      placementTypes
    }
  },
  computed: {
    ...mapFields('placementFilters', [
      'placementTypeId',
      'onlyFinalizedContracts',
      'dealStatusId',
      'businessEntityId',
      'clientId',
      'consultantId',
      'consultantName',
      'jobTitle'
    ])
  },
  watch: {
    businessEntityId () {
      this.clientId = null
    },
    placementTypeId () {
      this.onlyFinalizedContracts = false
      this.dealStatusId = null
      this.consultantId = null
      this.consultantName = null
    }
  },
  methods: {
    ...mapActions('placementFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleUserNameChange (firstName, lastName) {
      // Only set this value if the placement type is Direct Placement.
      // For Deals and Contracts, the SP can use the consultantId to filter.
      if (this.placementTypeId === placementTypes.DirectPlacement) {
        this.consultantName = firstName && lastName ? `${firstName} ${lastName}` : null
      } else {
        this.consultantName = null
      }
    },
    handleClearClick () {
      this.clientId = null
      this.consultantId = null
      this.consultantName = null
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
